export const bookSessionUrl =
  "https://bookings.cloud.microsoft/bookwithme/user/83a35e912f9342cc98c8c74da9f09e9b%40cloverbaytechnologies.com/meetingtype/E7UvQ5YvyUypWlJY7loK2g2?anonymous&ismsaljsauthenabled"
export const trustIndicators = [
  { label: "No Cost", icon: "shield" },
  { label: "No Obligation", icon: "ribbon" },
  { label: "Completely Confidential", icon: "lock" },
];

export const painPoints = [
  { label: "Slow Order Release", icon: "clock" },
  { label: "Inventory Sync Delays", icon: "sync" },
  { label: "Promise Latency", icon: "thunderbolt" },
  { label: "Orchestration Bottlenecks", icon: "cluster" },
  { label: "Integration Failures", icon: "disconnect" },
  { label: "Queue Build-up", icon: "bars" },
  { label: "JVM & Memory Tuning", icon: "memory" },
  { label: "Database Performance", icon: "database" },
  { label: "Agent Server Optimization", icon: "server" },
  { label: "Store Fulfillment", icon: "shop" },
  { label: "Distributed Scheduling", icon: "schedule" },
  { label: "High API Latency", icon: "api" },
];

export const deliverables = [
  {
    number: "01",
    color: "#635AD9",
    title: "Confidential Architecture Discussion",
    description: "A focused, 1:1 discussion with senior IBM Sterling OMS architects who understand real-world retail challenges."
  },
  {
    number: "02",
    color: "#219BE4",
    title: "Production Readiness Review",
    description:
      "We review your current architecture, integrations, and operational setup for peak readiness",
  },
  {
    number: "03",
    color: "#211C70",
    title: "Peak Readiness Recommendations",
    description: "Actionable recommendations prioritized by impact to help you strengthen stability, performance and scale."  },
  {
    number: "04",
    color: "#087ded",
    title: "Recommendation Summary",
    description:
      "A concise written summary that your team can use immediately to plan and execute improvements."
  },
];

export const architectureItems = [
  "Order Orchestration",
  "Inventory Visibility",
  "Sourcing",
  "Promise Engine",
  "Call Center",
  "Store Fulfillment",
  "Returns",
  "Integration Architecture",
  "Messaging",
  "Microservices",
  "API Performance",
];

export const operationalItems = [
  "Queue Monitoring",
  "Database Health",
  "Caching Strategy",
  "Performance Tuning",
  "Thread Pools",
  "Agent Servers",
  "JVM",
  "Error Handling",
  "Monitoring",
  "High Availability",
  "Disaster Recovery",
];

export const advisors = [
  {
    title: "Kiran Vernekar",
    href: "https://www.linkedin.com/in/kiran-vernekar-06b3bb2/",
    image: "kiran",
    color: "#635AD9",
    qualifications: [
      "20+ years of Sterling OMS implementation",
      "Enterprise OMS integrations",
      "Performance optimization & tuning",
      "Architecture reviews & scalability",
      "High volume & peak readiness expertise",
    ],
  },
  {
    title: "Prerna Sharma",
    href: "https://www.linkedin.com/in/prerna-sharma-715ba418/",
    image: "prerna",
    color: "#219BE4",
    qualifications: [
      "20+ years in retail fulfillment solutions",
      "Inventory & store fulfillment expertise",
      "Complex integrations & data flows",
      "Performance engineering specialist",
      "Omnichannel transformation advisor",
    ],
  },
  {
    title: "Rajiv Upadhyay",
    href: "https://www.linkedin.com/in/rajiv-upadhyay-744752",
    image: "rajiv",
    color: "#219BE4",
    qualifications: [
      "26+ years in retail fulfilment solutions",
      "Implemented solutions at scale in North America",
      "Omnichannel transformation advisor",
    ],
  },
];

export const processSteps = [
  {
    number: "01",
    title: "Book Your Session",
    description: "Pick a time that works for your team.",
    icon: "calendar",
  },
  {
    number: "02",
    title: "Sign Mutual NDA",
    description: "We sign a mutual NDA to ensure complete confidentiality.",
    icon: "document",
  },
  {
    number: "03",
    title: "60-minute Technical Workshop",
    description:
      "A deep-dive discussion with our architects on your challenges and environment.",
    icon: "team",
  },
  {
    number: "04",
    title: "Receive Recommendations",
    description:
      "Get a written summary with practical recommendations within 48 hours.",
    icon: "chart",
  },
  {
    number: "05",
    title: "Implement Internally or Engage Us (Your Choice)",
    description: "No obligation. You decide the next steps.",
    icon: "handshake",
  },
];

export const faqs = [
  {
    question: "Is this really free?",
    answer:
      "Yes. This is a complimentary service with no cost and no obligation.",
    icon: "question",
  },
  {
    question: "Will you try to sell services?",
    answer:
      "The session is focused on helping your team prepare for peak. Any discussion around engagement will be entirely your choice.",
    icon: "sales",
  },
  {
    question: "Do we need to share source code?",
    answer:
      "No. The discussion is architecture and configuration focused. No source code is required.",
    icon: "code",
  },
  {
    question: "Will recommendations remain confidential?",
    answer:
      "Absolutely. All discussions and information shared during the session are covered under NDA.",
    icon: "lock",
  },
  {
    question: "Can we discuss production incidents?",
    answer:
      "Yes. Many organizations use the session to review production issues, architecture concerns and performance bottlenecks before peak season.",
    icon: "alert",
  },
];

export const hubNodes = [
  "eCommerce",
  "POS/Stores",
  "WMS",
  "ERP",
  "Distribution Centers",
  "Carriers",
  "Inventory",
  "Marketplace",
  "Customers",
];
